import { defineMessages } from 'react-intl';

import * as reportActions from '../report-actions/constants';

export const actionsMessages = defineMessages({
  [reportActions.EXPORT_CSV]: {
    defaultMessage: 'CSV',
    id: 'aBCUND',
    description: 'Insights > Reports > Actions > Export to CSV',
  },
  [reportActions.EXPORT_EXCEL]: {
    defaultMessage: 'Excel',
    id: 'TppB5M',
    description: 'Insights > Reports > Actions > Export to Excel',
  },
  [reportActions.EXPORT_PDF]: {
    defaultMessage: 'PDF',
    id: '/NR750',
    description: 'Insights > Reports > Actions > Export to PDF',
  },
  [reportActions.EXPORT_TEXT]: {
    defaultMessage: 'Text',
    id: 'd0r56O',
    description: 'Insights > Reports > Actions > Export to Text',
  },
  [reportActions.RUN_REPORT]: {
    defaultMessage: 'Run Report',
    id: '7VDgwL',
    description: 'Insights > Reports > Actions > Run Report',
  },
  runActionToggler: {
    defaultMessage: 'Export to...',
    id: 'A3R5Ld',
    description: 'Insights > Reports > Actions > Export to...',
  },
});
